import { render, staticRenderFns } from "./ActivityListPage.vue?vue&type=template&id=61b89a02&scoped=true"
import script from "./ActivityListPage.vue?vue&type=script&lang=js"
export * from "./ActivityListPage.vue?vue&type=script&lang=js"
import style0 from "./ActivityListPage.vue?vue&type=style&index=0&id=61b89a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b89a02",
  null
  
)

export default component.exports